<template>
    <svg
        width="18"
        height="18"
        viewBox="0 1 18 18"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g>
            <path
                d="M9 15.9556L5.49375 17.1181C5.24375 17.2056 5.01562 17.1743 4.80938 17.0243C4.60313 16.8743 4.5 16.6743 4.5 16.4243V11.6618C4.025 11.1368 3.65625 10.5368 3.39375 9.86182C3.13125 9.18682 3 8.46807 3 7.70557C3 6.03057 3.58125 4.61182 4.74375 3.44932C5.90625 2.28682 7.325 1.70557 9 1.70557C10.675 1.70557 12.0938 2.28682 13.2563 3.44932C14.4187 4.61182 15 6.03057 15 7.70557C15 8.46807 14.8688 9.18682 14.6063 9.86182C14.3438 10.5368 13.975 11.1368 13.5 11.6618V16.4243C13.5 16.6743 13.3969 16.8743 13.1906 17.0243C12.9844 17.1743 12.7563 17.2056 12.5063 17.1181L9 15.9556ZM9 12.2056C10.25 12.2056 11.3125 11.7681 12.1875 10.8931C13.0625 10.0181 13.5 8.95557 13.5 7.70557C13.5 6.45557 13.0625 5.39307 12.1875 4.51807C11.3125 3.64307 10.25 3.20557 9 3.20557C7.75 3.20557 6.6875 3.64307 5.8125 4.51807C4.9375 5.39307 4.5 6.45557 4.5 7.70557C4.5 8.95557 4.9375 10.0181 5.8125 10.8931C6.6875 11.7681 7.75 12.2056 9 12.2056Z"
            />
            <path
                d="M8.31819 8.05092L10.8472 5.50399C10.9787 5.3605 11.1431 5.29174 11.3404 5.29772C11.5377 5.3037 11.7081 5.37246 11.8516 5.50399C11.9951 5.64748 12.0698 5.81787 12.0758 6.01517C12.0818 6.21247 12.013 6.38286 11.8695 6.52635L8.8204 9.57549C8.67691 9.71898 8.50951 9.79073 8.31819 9.79073C8.12687 9.79073 7.95947 9.71898 7.81598 9.57549L6.29141 8.05092C6.14792 7.90743 6.07617 7.73704 6.07617 7.53974C6.07617 7.34244 6.14792 7.17205 6.29141 7.02856C6.43489 6.88507 6.60529 6.81333 6.80259 6.81333C6.99988 6.81333 7.17028 6.88507 7.31377 7.02856L8.31819 8.05092Z"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'AmpifireVerified'
};
</script>
